import React from 'react'

const AccordionComponent = props => {
    const { Renderer } = props

    return <Renderer {...props} />
}

export default AccordionComponent
